import "core-js/modules/es.array.map.js";
import React from 'react';
import { ReadByStyled } from "../styles";
import ToolTip from "../../core/ui/ToolTip/ConstrainedToolTip";
var ReadBy = function ReadBy(_ref) {
  var readInfo = _ref.readInfo,
    readTooltip = _ref.readTooltip;
  if (!readInfo) return null;
  var tooltip = readTooltip && /*#__PURE__*/React.createElement(React.Fragment, null, readTooltip.map(function (text, key) {
    return /*#__PURE__*/React.createElement("div", {
      key: key
    }, text);
  }));
  return /*#__PURE__*/React.createElement(ReadByStyled, null, /*#__PURE__*/React.createElement("span", null, readInfo), tooltip && /*#__PURE__*/React.createElement(ToolTip, {
    name: "info-circle",
    text: tooltip
  }));
};
export default ReadBy;